import styled from "styled-components";

const ExperienceCard = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  gap: 20px;
  width: 100%;
  overflow-x: hidden;

  /* =============================
     SKILLS LIST
  ============================== */
  & .skills-list__skills {
    display: flex;
    flex-direction: row;
    gap: 12px;
    flex-wrap: wrap;
    max-width: 100%;
    overflow-x: auto; /* ✅ allows safe scroll if needed */
    -webkit-overflow-scrolling: touch;
  }

  /* =============================
     SKILL BUTTONS
  ============================== */
  & button {
    appearance: none;
    background-color: transparent;
    border: none;
    border-bottom: 2px solid #cdb8b88c;
    padding: 10px 20px;
    min-width: auto; /* ✅ remove fixed min-width */
    max-width: 100%;
    color: #ffffffb5;
    cursor: pointer;
    font-size: 0.9rem;
    white-space: nowrap; /* prevents text wrapping */
    transition: all 0.25s ease;
  }

  & button:hover {
    color: #64ffda;
    background-color: rgba(100, 255, 218, 0.05);
  }

  /* =============================
     SKILL CONTENT
  ============================== */
  & .skills-card__data {
    padding: 32px;
    border-radius: 8px;
    max-width: 100%;
    overflow-x: hidden;
  }

  /* =============================
     ACTIVE STATE
  ============================== */
  & .activeSkillSet {
    color: #64ffda;
    border-bottom-color: #64ffda;
    background-color: #122645;
  }

  /* =============================
     TABLETS (≤ 1024px)
  ============================== */
  @media (max-width: 1024px) {
    gap: 16px;

    & .skills-card__data {
      padding: 24px;
    }
  }

  /* =============================
     MOBILE / SMALL TABLET (≤ 768px)
  ============================== */
  @media (max-width: 768px) {
    flex-direction: column; /* ✅ FIX: stack instead of side-by-side */
    width: 100%;

    & .skills-list__skills {
      flex-direction: row;
      flex-wrap: nowrap;
      overflow-x: auto; /* ✅ horizontal scroll only for tabs */
    }

    & button {
      border-bottom: 2px solid #cdb8b88c;
      border-right: none;
      text-align: center;
      padding: 8px 14px;
      font-size: 0.85rem;
    }

    & .activeSkillSet {
      border-bottom-color: #64ffda;
    }

    & .skills-card__data {
      padding: 16px;
    }
  }

  /* =============================
     SMALL MOBILE (≤ 480px)
  ============================== */
  @media (max-width: 480px) {
    margin-top: 16px;

    & button {
      font-size: 0.8rem;
      padding: 6px 12px;
    }

    & .skills-card__data {
      padding: 12px;
    }
  }
`;

export default ExperienceCard;
